<template>
<div class="loader-box"  :class="{'inline':type=='inline'}" v-if="show">
    <div class="loader">
        
    </div>
</div>
</template>

<script>
export default {
    name: "Loader",
    props:['show','type'],
    methods:{

    }
};
</script>

<style scoped>
.loader-box {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(255,255,255,.8);
    top: 0px;
    left: 0px;
    z-index: 2500;
    display: flex;
    justify-content:center;
    align-items: center;
}
.loader-box.inline{
    /* height: 600px; */
    margin-top:18px;
    margin-bottom:18px;
    position: relative;
    background-color: transparent;
}
.loader{
  width: 36px;
  height: 36px;
  border: 4px solid;
  border-color: #21262c transparent #21262c transparent;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
